export default "__VITE_ASSET__cQaJogqW__"